import styled from "styled-components";

export const Container = styled.header`
  height: 130px;
  background-color: #f8f6f5;
  display: flex;
  justify-content: center;
  padding: 0 20px;
  border-bottom: 5px solid #1d364a;

  @media (max-width: 920px) {
    height: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  max-width: 1262px;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  div {
    font-family: "Montserrat";
    font-size: 15px;
    display: flex;
    gap: 10px;
  }

  a {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    color: #1d364a;
  }

  @media (max-width: 920px) {
    flex-direction: column;
    gap: 10px;
    padding: 20px 0;

    div {
      flex-direction: column;
    }
  }

  @media (max-width: 425px) {
    div {
      font-size: 13px;
    }
  }
`;

export const ImageLogo = styled.img`
  max-width: 360px;
  width: 100%;
  height: 62px;

  @media (max-width: 920px) {
    max-width: 200px;
  }
`;
